import React from "react";
import { NavLink } from "react-router-dom";

import dsd from "../classes/clsDSD";
import { getCodeList } from "../utils/utilsCodeList";

class TreeCodeList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            CodeList: null,
        };
        this.dsd = new dsd();
    }

    componentDidMount() {
        this.loadCodeList();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.idCodeList !== this.props.idCodeList || prevProps.idItem !== this.props.idItem) {
            this.loadCodeList();
        }
    }

    loadCodeList() {
        const { idCodeList } = this.props;
        if (!idCodeList) { return; }

        const onLoad = (data) => {
            this.setState({ CodeList: data }, () => {
                this.reportCount();
            });
        };

        getCodeList(this.dsd, idCodeList, onLoad, null);
    }

    reportCount() {
        const { onLoad, idItem } = this.props;
        if (!onLoad) { return; }
        const { CodeList } = this.state;
        if (!CodeList || !CodeList.Codes) { onLoad(0); return; }

        const isActive = (code) => !code.status || code.status === 'in use';
        const codesById = {};
        for (const code of CodeList.Codes) {
            if (code && code._id) {
                codesById[String(code._id)] = code;
            }
        }

        const getChildren = (code) => {
            if (!code || !Array.isArray(code.Children)) { return []; }
            return code.Children
                .map(child => codesById[String(child.idCode)])
                .filter(Boolean);
        };

        if (idItem) {
            // Count all active descendants of idItem (mirroring the recursive tree render)
            const countDescendants = (id, visited) => {
                const node = codesById[String(id)];
                const children = getChildren(node);
                let total = 0;
                for (const child of children) {
                    if (!isActive(child)) { continue; }
                    const childId = String(child._id);
                    if (visited.has(childId)) { continue; }
                    const next = new Set(visited);
                    next.add(childId);
                    total += 1 + countDescendants(childId, next);
                }
                return total;
            };
            onLoad(countDescendants(idItem, new Set([String(idItem)])));
        } else {
            // Count only active codes
            onLoad(CodeList.Codes.filter(isActive).length);
        }
    }

    render() {
        const { idItem } = this.props;
        const { CodeList } = this.state;

        if (!CodeList || !CodeList.Codes) { return null; }

        const codes = CodeList.Codes;
        const codesById = {};
        for (const code of codes) {
            if (code && code._id) {
                codesById[String(code._id)] = code;
            }
        }

        const getChildren = (code) => {
            if (!code || !Array.isArray(code.Children)) { return []; }
            return code.Children
                .map(child => codesById[String(child.idCode)])
                .filter(Boolean);
        };

        const renderNode = (code, depth, visited) => {
            if (code.status && code.status !== 'in use') { return null; }
            const idStr = String(code._id);
            if (visited.has(idStr)) { return null; }
            const nextVisited = new Set(visited);
            nextVisited.add(idStr);
            const children = getChildren(code);
            return (
                <div key={`${idStr}-${depth}`} style={{ paddingLeft: depth * 20 }}>
                    <NavLink to={`/item/${idStr}`}>{code.code}</NavLink>
                    {code.label ? ` - ${code.label}` : ''}
                    {children.map(child => renderNode(child, depth + 1, nextVisited))}
                </div>
            );
        };

        if (idItem) {
            // Show children of the specified item only
            const children = getChildren(codesById[String(idItem)]);
            if (children.length === 0) {
                return <div>No children.</div>;
            }
            return (
                <div>
                    {children.map(child => renderNode(child, 0, new Set([String(idItem)])))}
                </div>
            );
        }

        // Show full tree: roots are codes with no parents
        const roots = codes.filter(c => !c.Parents || c.Parents.length === 0);
        const displayRoots = roots.length > 0 ? roots : codes;

        return (
            <div>
                {displayRoots.map(root => renderNode(root, 0, new Set()))}
            </div>
        );
    }
}

export default TreeCodeList;
